import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class PolizaContable extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: '', saveUrl: '', backUrl: '' },
      new Form([
        Form.Field('date', 'date', 'Fecha', '', [Validators.required], 6)
      ], ['Descargar'], 'Poliza Contable'), this.formData)
    
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { date } = vals;
    const start = moment(date).format('YYYY-MM-DD');
    const Resp = await Http.get(`cuenta-contable/1?q=1&fecha=${start}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `poliza_contable_${start}.xls`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(PolizaContable)
